import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FaCaretDown, FaCaretUp } from 'react-icons/fa';
import Caret from '../Caret'
import Tooltip from '../Tooltip'
import classNames from 'classnames';
import styles from './Table.module.scss';

class Table extends React.PureComponent {
  constructor (props, context) {
    super(props, context)
    this.state = {
      sortColumn: this.props.sortColumn,
      sortDirection: this.props.sortDirection || 'unset',
      expandedRows: {}
    }

    this.onSorting = this.onSorting.bind(this);
  }

  componentDidMount () {
    if (this.props.defaultExpanded) {     
      let expandedRows = {};

      this.props.data.forEach((item, i) => {
        if (this.props.expandedSection(item)) {
          expandedRows = {...expandedRows, [i]: true}
        }
      });

      this.setState({ expandedRows })
    }
  }

  componentWillUpdate (nextProps) {
    if (this.props.defaultExpanded !== nextProps.defaultExpanded) {
      if (nextProps.defaultExpanded) {     
        let expandedRows = {};
  
        nextProps.data.forEach((item, i) => {
          if (nextProps.expandedSection(item)) {
            expandedRows = {...expandedRows, [i]: true}
          }
        });
  
        this.setState({ expandedRows })
      } else {
        this.setState({ expandedRows: {} })
      }
    }

    if (this.props.currentPage !== nextProps.currentPage && !this.props.defaultExpanded) {
      this.setState({ expandedRows: {} })
    }
  }

  expandRow = (i) => {
    const expanded = this.state.expandedRows[i] !== undefined ? !this.state.expandedRows[i] : true
    const expandedRows = {...this.state.expandedRows, [i]: expanded}
    this.setState({ expandedRows })
  }

  onSorting (column) {
    let sortDirection = 'unset';

    if (column.sortDirection === 'DESC' && this.state.sortDirection !== 'DESC') {
      sortDirection = 'DESC'
    } else if (this.state.sortDirection === 'ASC' && this.state.sortColumn === (column.sortingKey || column.name)) {
      sortDirection = 'DESC'
    } else {
      sortDirection = 'ASC'
    }

    this.setState({
      sortDirection: sortDirection,
      sortColumn: column.sortingKey || column.name,
      expandedRows: {}
    }, () => {
      if ( this.props.onSort) {
        this.props.onSort(column, sortDirection);
      }
    })
  }

  render () {
    const { className, columns, expandedSection, expandName, expandedBG, size, stickyHeader, wordWrap, wordBreak } = this.props;
    let data = this.props.data;
    if (this.props.max) data = data.slice(0, this.props.max);
    
    return (
      <div className={className}>
        <div className={styles.tableContainer}>
          <table id={'table'} className={classNames(styles.table,{
            [styles.overline]: this.props.overline,
            [styles.thickOverline]: this.props.thickOverline
          })}>
            {this.props.showHeader && <thead>
              <tr>
              {columns && columns.map(column => (
                <th key={`tableHead${column.name}`} className={classNames(styles.cell, {
                  [styles.sticky]: stickyHeader,
                  [styles.small]: size === 'small',
                  [styles[column.align]]: column.align,
                  [styles.hideOnMobile]: column.hideOnMobile,
                  [styles.hideOnTablet]: column.hideOnTablet,
                  [styles.wrap] : wordWrap,
                  [styles.break] : wordBreak,
                  [styles.clickable]: column.sortingEnabled
                })}
                onClick={column.sortingEnabled ? () => this.onSorting(column) : undefined}>
                  {column.header || column.name}
                  {this.state.sortDirection === 'ASC' && this.state.sortColumn === (column.sortingKey || column.name) && <FaCaretUp />}
                  {this.state.sortDirection === 'DESC' && this.state.sortColumn === (column.sortingKey || column.name) && <FaCaretDown />}
                </th>
              ))}
              {this.props.expandedSection && <th className={classNames(styles.cell, styles.right,
                {[styles.small]: size === 'small',
                [styles.sticky]: stickyHeader}
              )}>{expandName && expandName}</th>}
              </tr>
            </thead>}
            <tbody className={classNames({
              [styles.striped]: this.props.stripedTable
            })}>
              {data && data.map((item, i) => {
                return [<tr key={`tableRow${i}`} className={classNames(styles.row, {
                  [styles.rowClick]: this.props.onRowClick || this.props.rowClickExpand
                })} onClick={() => this.props.onRowClick && this.props.onRowClick(item) || this.props.rowClickExpand && this.expandRow(i)}>
                  {this.props.columns.map(column => {
                    let strLinkTo = null;
                    let emptyValue = !item[column.name] && (column.emptyValue || '–');
                    
                    if (column.linkTo) {
                      strLinkTo = typeof column.linkTo === 'string' ? column.linkTo : column.linkTo(item)
                    }

                    let tooltip = null
                    if (column.tooltip) {
                      tooltip = typeof column.tooltip === 'function' ? column.tooltip(item) : column.tooltip
                    }

                    const cellContent = <span className={column.bold && styles.bold}>
                      {/* Custom component */}
                      {column.component && <span>{<column.component item={item}/>}</span>}
                      {/* Text Link To */}
                      {strLinkTo && <Link to={strLinkTo} className={styles.link}>{item[column.name] || emptyValue}</Link>}
                      {/* Text HREF */}
                      {column.href && <a href={column.href} className={styles.link}>{item[column.name] || emptyValue}</a>}
                      {/* Regular Text */}
                      {!column.component && !strLinkTo && !column.href && <span>{item[column.name] || emptyValue}</span>}
                    </span> 
                    
                    return <td key={`tableCell${column.name}`} id={column.name} className={classNames(styles.cell, {
                      [styles.small]: size === 'small',
                      [styles[column.align]]: true, 
                      [styles.hideOnMobile]: column.hideOnMobile,
                      [styles.hideOnTablet]: column.hideOnTablet,
                      [styles.wrap] : wordWrap || column.wordWrap,
                      [styles.break] : wordBreak || column.wordBreak
                    })}>
                      {tooltip ? <Tooltip {...tooltip}>
                        {cellContent}
                      </Tooltip> : cellContent}
                  </td>
                  })}
                  {/* Expandable */}
                  {expandedSection && expandedSection(item) && 
                    <td id={'column.name'} className={classNames(styles.cell, styles.right, {
                      [styles.small]: size === 'small',
                    })}>
                      <span className={styles.expandIcon} onClick={() => this.expandRow(i)}>
                        <Caret isOpen={this.state.expandedRows[i]} />
                      </span>
                    </td>
                  }
                  {/* Empty Cell for null expanded section */}
                  {expandedSection && !expandedSection(item) && <td className={classNames(styles.cell, {[styles.small]: size === 'small'})}></td>}
                </tr>,
                expandedSection && expandedSection(item) && this.state.expandedRows[i] && <tr key={`tableExpand${i}`}>
                  <td className={classNames(styles.expanded, {[styles.small]: size === 'small'})} style={{'backgroundColor': expandedBG}} colSpan={columns.length + 1}>{expandedSection(item)}</td>
                </tr>]
              })}
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

Table.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    /** column key in source data */
    name: PropTypes.string.isRequired,
    /** column display name for headers */
    header: PropTypes.string,
    /** column display name for headers in mobile */
    headerShort: PropTypes.string,
    /** column alignment: "left", "center", "right" */
    align: PropTypes.oneOf(['left', 'center', 'right']),
    /** hide column in mobile displays? */
    hideOnMobile: PropTypes.bool,
    /** hide column in tablet displays? */
    hideOnTablet: PropTypes.bool,
    /** bold values */
    bold: PropTypes.bool,
    /** sorting enabled */
    sortingEnabled: PropTypes.bool,
    /** sorting key (column.name will be used if unavailable) */
    sortingKey: PropTypes.string,
    /** custom column component */
    component: PropTypes.func,
    /** text to display if cell value is null or undefined */
    emptyValue: PropTypes.string,
    /* allow strings in cell to wrap */
    wordWrap: PropTypes.bool,
    /** allow strings in cells to break */
    wordBreak: PropTypes.bool,
    /**
     * simple string or function that generates link string from item data,
     * i.e. `(item) => '/test/' + item._id`
     */
    linkTo: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    /** link outside of app */
    href: PropTypes.href,
    /**
     * object or function that generates tooltip from item data,
     * i.e. `(item) => ({ text: item.field })`
     */
    tooltip: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
  })).isRequired,
  /** items to render */
  data: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object),
  ]),
  /** Enable row clicking ability */
  onRowClick: PropTypes.func,
  /** show column headers (by column.header or column.name if unavailable) */
  showHeader: PropTypes.bool,
  /** function that generates expanded content from item data */
  expandedSection: PropTypes.func,
  /** if expandedSection exist option to provide a column name to expanded icon column (not required) */
  expandName: PropTypes.string,
  /** give expanded row a hex value color */
  expandedBG: PropTypes.string,
  /** show green top border */
  overline: PropTypes.bool,
  /** thick green top border */
  thickOverline: PropTypes.bool,
  /** current sorted column */
  sortColumn: PropTypes.string,
  /** sorting direction */
  sortDirection: PropTypes.oneOf(['ASC', 'unset', 'DESC']),
  /** sort callback */
  onSorting: PropTypes.func,
  /** custom className */
  className: PropTypes.string,
  /** max amount of data items to shouw */
  max: PropTypes.number,
  /** default the first expanded state */
  defaultExpanded: PropTypes.bool,
  /** wordWrap allow strings in cells to wrap */
  wordWrap: PropTypes.bool,
  /** wordBreak allow strings in cells to break */
  wordBreak: PropTypes.bool,
  /** Size of table: font, row height */
  size: PropTypes.oneOf(['small', 'default']),
  /** Fixed position for TH elements. Give outer element a max height and set overflow y to scroll */
  stickyHeader: PropTypes.bool,
  /** Allow a row to be clicked to expand */
  rowClickExpand: PropTypes.bool,
  /** Alternate row background color */
  stripedTable: PropTypes.bool,
  currentPage: PropTypes.number
}

Table.defaultProps = {
  showHeader: true,
  expandedBG: 'transparent',
  wordWrap: false,
  wordBreak: false,
  defaultExpanded: false,
  thickOverline: false,
  size: 'default'
}

export default Table
